import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M13 13V19H11V13H5V11H11V5H13V11H19V13H13Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "Plus"
);
